import React, { useEffect } from 'react'
import Footer from '../Footer'

import './PrivacyPolicy.scss'

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="PrivacyPolicy">
      <p>
        <span>
          This Privacy Policy describes how www.ropeandladder.com (the
          &ldquo;Site&rdquo; or &ldquo;we&rdquo;) collects, uses, and discloses
          your Personal Information when you visit or make a purchase from the
          Site.
        </span>
      </p>
      <h1 className="c19 c18" id="h.b0ourmgkz2et">
        <span className="c20 c17">Collecting Personal Information</span>
      </h1>
      <p>
        <span>
          When you visit the Site, we collect certain information about your
          device, your interaction with the Site, and information necessary to
          process your purchases. We may also collect additional information if
          you contact us for customer support. In this Privacy Policy, we refer
          to any information that can uniquely identify an individual (including
          the information below) as &ldquo;Personal Information&rdquo;. See the
          list below for more information about what Personal Information we
          collect and why.
        </span>
      </p>
      <p>
        <span className="c24 c13">Device information</span>
      </p>
      <ul className="c11 lst-kix_tn8dacqinnr-0 start">
        <li>
          <span className="c17 c13">
            Examples of Personal Information collected:
          </span>
          <span>
            &nbsp;version of web browser, IP address, time zone, cookie
            information, what sites or products you view, search terms, and how
            you interact with the Site.
          </span>
        </li>
        <li>
          <span className="c17 c13">Purpose of collection:</span>
          <span>
            &nbsp;to load the Site accurately for you, and to perform analytics
            on Site usage to optimize our Site.
          </span>
        </li>
        <li>
          <span className="c17 c13">Source of collection:</span>
          <span>
            &nbsp;Collected automatically when you access our Site using
            cookies, log files, web beacons, tags, or pixels.
          </span>
        </li>
        <li>
          <span className="c17 c13">Disclosure for a business purpose:</span>
          <span>&nbsp;shared with our processor Shopify.</span>
        </li>
      </ul>
      <p>
        <span className="c13 c24">Order information</span>
      </p>
      <ul className="c11 lst-kix_hn1lvzvziin2-0 start">
        <li>
          <span className="c13 c17">
            Examples of Personal Information collected:
          </span>
          <span>
            &nbsp;name, billing address, shipping address, payment information
            (including credit card numbers), email address, and phone number.
          </span>
        </li>
        <li>
          <span className="c17 c13">Purpose of collection:</span>
          <span>
            &nbsp;to provide products or services to you to fulfill our
            contract, to process your payment information, arrange for shipping,
            and provide you with invoices and/or order confirmations,
            communicate with you, screen our orders for potential risk or fraud,
            and when in line with the preferences you have shared with us,
            provide you with information or advertising relating to our products
            or services.
          </span>
        </li>
        <li>
          <span className="c17 c13">Source of collection:</span>
          <span>&nbsp;collected from you.</span>
        </li>
        <li>
          <span className="c17 c13">Disclosure for a business purpose:</span>
          <span>&nbsp;shared with our processor Shopify.</span>
        </li>
      </ul>
      <p>
        <span className="c24 c13">Customer support information</span>
      </p>
      <ul className="c11 lst-kix_go5rkfec0hk4-0 start">
        <li>
          <span className="c17 c13">
            Examples of Personal Information collected:
          </span>
          <span className="c13">&nbsp;</span>
          <span className="c21 c0">name, email</span>
        </li>
        <li>
          <span className="c17 c13">Purpose of collection:</span>
          <span>&nbsp;to provide customer support.</span>
        </li>
        <li>
          <span className="c17 c13">Source of collection:</span>
          <span>&nbsp;collected from you.</span>
        </li>
      </ul>
      <h1 className="c19 c18" id="h.oxy2rkkz00ys">
        <span className="c20 c17">Sharing Personal Information</span>
      </h1>
      <p>
        <span>
          We share your Personal Information with service providers to help us
          provide our services and fulfill our contracts with you, as described
          above. For example:
        </span>
      </p>
      <ul className="c11 lst-kix_qw444w3658kt-0 start">
        <li>
          <span className="c13">
            We use Shopify to power our online store. You can read more about
            how Shopify uses your Personal Information here:{' '}
          </span>
          <span className="c12">
            <a
              className="c14"
              href="https://www.google.com/url?q=https://www.shopify.com/legal/privacy&amp;sa=D&amp;ust=1606777728650000&amp;usg=AOvVaw2loaPLhY5YKfb7PvRAo0Gu"
            >
              https://www.shopify.com/legal/privacy
            </a>
          </span>
          <span>.</span>
        </li>
        <li>
          <span className="c13">
            We may share your Personal Information to comply with applicable
            laws and regulations, to respond to a subpoena, search warrant or
            other lawful request for information we receive, or to otherwise
            protect our rights.
          </span>
        </li>
      </ul>
      <h2 id="h.hqb3j050ial8">
        <span>Behavioural Advertising</span>
      </h2>
      <p>
        <span>
          As described above, we use your Personal Information to provide you
          with targeted advertisements or marketing communications we believe
          may be of interest to you. For example:
        </span>
      </p>
      <ul className="c11 lst-kix_2mdgiz64z512-0 start">
        <li>
          <span className="c13">
            We use Google Analytics to help us understand how our customers use
            the Site. You can read more about how Google uses your Personal
            Information here:{' '}
          </span>
          <span className="c12">
            <a
              className="c14"
              href="https://www.google.com/url?q=https://policies.google.com/privacy?hl%3Den&amp;sa=D&amp;ust=1606777728651000&amp;usg=AOvVaw1NMZyQ-K80sn2EVXhRH5f2"
            >
              https://policies.google.com/privacy?hl=en
            </a>
          </span>
          <span className="c13">
            .You can also opt-out of Google Analytics here:{' '}
          </span>
          <span className="c12">
            <a
              className="c14"
              href="https://www.google.com/url?q=https://tools.google.com/dlpage/gaoptout&amp;sa=D&amp;ust=1606777728651000&amp;usg=AOvVaw1RgFSJS0bE6XHX9_lAcSvX"
            >
              https://tools.google.com/dlpage/gaoptout
            </a>
          </span>
          <span>.</span>
        </li>
      </ul>
      <p>
        <span className="c13">
          For more information about how targeted advertising works, you can
          visit the Network Advertising Initiative&rsquo;s (&ldquo;NAI&rdquo;)
          educational page at{' '}
        </span>
        <span className="c12">
          <a
            className="c14"
            href="https://www.google.com/url?q=http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work&amp;sa=D&amp;ust=1606777728651000&amp;usg=AOvVaw3FzSn7X7CQlVdw19qi7nWo"
          >
            http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work
          </a>
        </span>
        <span>.</span>
      </p>
      <p>
        <span>You can opt out of targeted advertising by:</span>
      </p>
      <ul className="c11 lst-kix_x20r9a70gzqn-0 start">
        <li>
          <span>FACEBOOK - </span>
          <span className="c12">
            <a
              className="c14"
              href="https://www.google.com/url?q=https://www.facebook.com/settings/?tab%3Dads&amp;sa=D&amp;ust=1606777728652000&amp;usg=AOvVaw2hcd7eOv8Yvx8c_JGMc0bX"
            >
              https://www.facebook.com/settings/?tab=ads
            </a>
          </span>
        </li>
        <li>
          <span>GOOGLE - </span>
          <span className="c12">
            <a
              className="c14"
              href="https://www.google.com/url?q=https://www.google.com/settings/ads/anonymous&amp;sa=D&amp;ust=1606777728652000&amp;usg=AOvVaw2ceTpTxZecKVfD9b1bIqeF"
            >
              https://www.google.com/settings/ads/anonymous
            </a>
          </span>
        </li>
      </ul>
      <p>
        <span className="c13">
          Additionally, you can opt out of some of these services by visiting
          the Digital Advertising Alliance&rsquo;s opt-out portal at:{' '}
        </span>
        <span className="c12">
          <a
            className="c14"
            href="https://www.google.com/url?q=http://optout.aboutads.info/&amp;sa=D&amp;ust=1606777728653000&amp;usg=AOvVaw38ZI3SQqpk3YYm7svVl_gx"
          >
            http://optout.aboutads.info/
          </a>
        </span>
        <span>.</span>
      </p>
      <h1 className="c19 c18" id="h.j8ykux6pst33">
        <span className="c20 c17">Using Personal Information</span>
      </h1>
      <p>
        <span>
          We use your personal Information to provide our services to you, which
          includes: offering products for sale, processing payments, shipping
          and fulfillment of your order, and keeping you up to date on new
          products, services, and offers.
        </span>
      </p>
      <h2 id="h.yfl61wgnfdrt">
        <span>Lawful basis</span>
      </h2>
      <p>
        <span>
          Pursuant to the General Data Protection Regulation
          (&ldquo;GDPR&rdquo;), if you are a resident of the European Economic
          Area (&ldquo;EEA&rdquo;), we process your personal information under
          the following lawful bases:
        </span>
      </p>
      <ul className="c11 lst-kix_9on99zoiwsm0-0 start">
        <li>
          <span>The performance of the contract between you and the Site;</span>
        </li>
        <li>
          <span>Compliance with our legal obligations;</span>
        </li>
      </ul>
      <h2 id="h.l3ur6shqqdrq">
        <span>Retention</span>
      </h2>
      <p>
        <span>
          When you place an order through the Site, we will retain your Personal
          Information for our records unless and until you ask us to erase this
          information. For more information on your right of erasure, please see
          the &lsquo;Your rights&rsquo; section below.
        </span>
      </p>
      <h2 id="h.dlc04oduv4l6">
        <span>Automatic decision-making</span>
      </h2>
      <p>
        <span>
          If you are a resident of the EEA, you have the right to object to
          processing based solely on automated decision-making (which includes
          profiling), when that decision-making has a legal effect on you or
          otherwise significantly affects you.
        </span>
      </p>
      <p>
        <span>
          We do not engage in fully automated decision-making that has a legal
          or otherwise significant effect using customer data.
        </span>
      </p>
      <p>
        <span>
          Our processor Shopify uses limited automated decision-making to
          prevent fraud that does not have a legal or otherwise significant
          effect on you.
        </span>
      </p>
      <p>
        <span>
          Services that include elements of automated decision-making include:
        </span>
      </p>
      <ul className="c11 lst-kix_4ecbfhlld66-0 start">
        <li>
          <span>
            Temporary denylist of IP addresses associated with repeated failed
            transactions. This denylist persists for a small number of hours.
          </span>
        </li>
        <li>
          <span>
            Temporary denylist of credit cards associated with denylisted IP
            addresses. This denylist persists for a small number of days.Your
            rights
          </span>
        </li>
      </ul>
      <h2 id="h.u66bmoy5w5un">
        <span>GDPR</span>
      </h2>
      <p>
        <span className="c13">
          If you are a resident of the EEA, you have the right to access the
          Personal Information we hold about you, to port it to a new service,
          and to ask that your Personal Information be corrected, updated, or
          erased. If you would like to exercise these rights, please contact us
          through the contact information below
        </span>
        <span className="c21 c0">.</span>
      </p>
      <p>
        <span className="c13">
          Your Personal Information will be initially processed in Ireland and
          then will be transferred outside of Europe for storage and further
          processing, including to Canada and the United States. For more
          information on how data transfers comply with the GDPR, see
          Shopify&rsquo;s GDPR Whitepaper:{' '}
        </span>
        <span className="c12">
          <a
            className="c14"
            href="https://www.google.com/url?q=https://help.shopify.com/en/manual/your-account/privacy/GDPR&amp;sa=D&amp;ust=1606777728655000&amp;usg=AOvVaw298w0LoXS-W7pAwj670nXQ"
          >
            https://help.shopify.com/en/manual/your-account/privacy/GDPR
          </a>
        </span>
        <span>.</span>
      </p>
      <h2 id="h.he9awsq3177h">
        <span>CCPA</span>
      </h2>
      <p>
        <span>
          If you are a resident of California, you have the right to access the
          Personal Information we hold about you (also known as the &lsquo;Right
          to Know&rsquo;), to port it to a new service, and to ask that your
          Personal Information be corrected, updated, or erased. If you would
          like to exercise these rights, please contact us through the contact
          information below.
        </span>
      </p>
      <p>
        <span>
          If you would like to designate an authorized agent to submit these
          requests on your behalf, please contact us at the address below.
        </span>
      </p>
      <h1 className="c19 c18" id="h.ew1sp0zrae3">
        <span className="c20 c17">Cookies</span>
      </h1>
      <p>
        <span>
          A cookie is a small amount of information that&rsquo;s downloaded to
          your computer or device when you visit our Site. We use a number of
          different cookies, including functional, performance, advertising, and
          social media or content cookies. Cookies make your browsing experience
          better by allowing the website to remember your actions and
          preferences (such as login and region selection). This means you
          don&rsquo;t have to re-enter this information each time you return to
          the site or browse from one page to another. Cookies also provide
          information on how people use the website, for instance whether
          it&rsquo;s their first time visiting or if they are a frequent
          visitor.
        </span>
      </p>
      <p>
        <span>
          We use the following cookies to optimize your experience on our Site
          and to provide our services.
        </span>
      </p>
      <h2 id="h.lvld5rg8dv8j">
        <span>Cookies Necessary for the Functioning of the Store</span>
      </h2>
      <span id="t.b26c6f69fe2198f257886260eb1635facf3c831e"></span>
      <span id="t.0"></span>
      <table className="c16">
        <tbody>
          <tr className="c23">
            <td colSpan={1} rowSpan={1}>
              <p className="c22 c18">
                <span className="c17 c13">Name</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p className="c22 c18">
                <span className="c17 c13">Function</span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p className="c7 c18">
                <span>_ab</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>Used in connection with access to admin.</span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>_secure_session_id</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>
                  Used in connection with navigation through a storefront.
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>cart</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>Used in connection with shopping cart.</span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>cart_sig</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>Used in connection with checkout.</span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>cart_ts</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>Used in connection with checkout.</span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>checkout_token</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>Used in connection with checkout.</span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>secret</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>Used in connection with checkout.</span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>secure_customer_sig</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>Used in connection with customer login.</span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>storefront_digest</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>Used in connection with customer login.</span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>_shopify_u</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>
                  Used to facilitate updating customer account information.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <h2 id="h.1lgnnxvylczr">
        <span>Reporting and Analytics</span>
      </h2>
      <table className="c16">
        <tbody>
          <tr className="c23">
            <td colSpan={1} rowSpan={1}>
              <p className="c18 c22">
                <span className="c17 c13">Name</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p className="c22 c18">
                <span className="c17 c13">Function</span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p className="c7 c18">
                <span>_tracking_consent</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>Tracking preferences.</span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>_landing_page</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>Track landing pages</span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>_orig_referrer</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>Track landing pages</span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>_s</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>Shopify analytics.</span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>_shopify_fs</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>Shopify analytics.</span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>_shopify_s</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>Shopify analytics.</span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>_shopify_sa_p</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>
                  Shopify analytics relating to marketing &amp; referrals.
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>_shopify_sa_t</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>
                  Shopify analytics relating to marketing &amp; referrals.
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>_shopify_y</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>Shopify analytics.</span>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>_y</span>
              </p>
            </td>
            <td colSpan={1} rowSpan={1}>
              <p>
                <span>Shopify analytics.</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p className="c1 c15">
        <span></span>
      </p>
      <p>
        <span>
          The length of time that a cookie remains on your computer or mobile
          device depends on whether it is a &ldquo;persistent&rdquo; or
          &ldquo;session&rdquo; cookie. Session cookies last until you stop
          browsing and persistent cookies last until they expire or are deleted.
          Most of the cookies we use are persistent and will expire between 30
          minutes and two years from the date they are downloaded to your
          device.
        </span>
      </p>
      <p>
        <span>
          You can control and manage cookies in various ways. Please keep in
          mind that removing or blocking cookies can negatively impact your user
          experience and parts of our website may no longer be fully accessible.
        </span>
      </p>
      <p>
        <span className="c13">
          Most browsers automatically accept cookies, but you can choose whether
          or not to accept cookies through your browser controls, often found in
          your browser&rsquo;s &ldquo;Tools&rdquo; or &ldquo;Preferences&rdquo;
          menu. For more information on how to modify your browser settings or
          how to block, manage or filter cookies can be found in your
          browser&rsquo;s help file or through such sites as{' '}
        </span>
        <span className="c12">
          <a
            className="c14"
            href="https://www.google.com/url?q=https://rope-and-ladder.myshopify.com/admin/settings/www.allaboutcookies.org&amp;sa=D&amp;ust=1606777728678000&amp;usg=AOvVaw21NARP7f3bPfG-GPyJqWd3"
          >
            www.allaboutcookies.org
          </a>
        </span>
        <span>.</span>
      </p>
      <p>
        <span>
          Additionally, please note that blocking cookies may not completely
          prevent how we share information with third parties such as our
          advertising partners. To exercise your rights or opt-out of certain
          uses of your information by these parties, please follow the
          instructions in the &ldquo;Behavioural Advertising&rdquo; section
          above.
        </span>
      </p>
      <h2 id="h.9p2oauggjplx">
        <span>Do Not Track</span>
      </h2>
      <p>
        <span>
          Please note that because there is no consistent industry understanding
          of how to respond to &ldquo;Do Not Track&rdquo; signals, we do not
          alter our data collection and usage practices when we detect such a
          signal from your browser.
        </span>
      </p>
      <h1 className="c18 c19" id="h.8hagioig8h33">
        <span className="c20 c17">Changes</span>
      </h1>
      <p>
        <span>
          We may update this Privacy Policy from time to time in order to
          reflect, for example, changes to our practices or for other
          operational, legal, or regulatory reasons.
        </span>
      </p>
      <h1 className="c19 c18" id="h.7p7ag0cwweb">
        <span className="c17 c20">Contact</span>
      </h1>
      <p>
        <span>
          For more information about our privacy practices, if you have
          questions, or if you would like to make a complaint, please contact us
          by e-mail at jay@ropeandladder.com or by mail using the details
          provided below:
        </span>
      </p>
      <p>
        <span>12 Willard Circle, Andover MA 01810, United States</span>
      </p>
      <p className="c7 c18">
        <span className="c13">Last updated: </span>
        <span className="c0 c21">11/29/2020</span>
      </p>
      <p>
        <span>
          If you are not satisfied with our response to your complaint, you have
          the right to lodge your complaint with the relevant data protection
          authority.
        </span>
      </p>
      <Footer />
    </div>
  )
}

export default PrivacyPolicy
